// extracted by mini-css-extract-plugin
module.exports = {"showProducts":"surfaceProducts_showProducts__2DkK0","submenu":"surfaceProducts_submenu__SNx5d","Categories":"surfaceProducts_Categories__21OAv"};